// Feature flags for AIPrep frontend

export const FEATURES = {
  // Use GitHub-style side panel chat instead of modal
  // Set REACT_APP_SIDE_PANEL_CHAT=true in .env to enable
  USE_SIDE_PANEL_CHAT: process.env.REACT_APP_SIDE_PANEL_CHAT !== 'false', // Enabled by default

  // Add more feature flags here as needed
} as const;

export type FeatureFlags = typeof FEATURES;

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (feature: keyof FeatureFlags): boolean => {
  return FEATURES[feature];
};
